<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-09-18 11:37:22
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-10-13 11:43:52
 * @FilePath: \合联\vnlin-portal\src\view\workOrder\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="chat-main" ref="main">
    <div
      v-if="loading"
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.3);
        color: white;
        z-index: 999999;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      "
    >
      <Button loading shape="circle" type="primary"></Button>
      <div>loading...</div>
    </div>
    <div class="message-box" ref="message">
      <div
        v-for="(item, i) in messages"
        :class="item.type == type ? 'left' : 'right'"
        :key="i"
      >
        <img
          v-if="item.type == type && type == 2"
          class="avatar"
          :src="serviceIcon"
        />
        <div>
          <div>
            <span v-if="item.type == type" class="username">{{
              item.user_name
            }}</span>
            <span class="time">{{ item.create_time }}</span>
          </div>
          <div class="message" v-if="item.describe">
            <span class="text">{{ item.describe }}</span>
          </div>
          <div class="image" v-if="item.src">
            <img
              :src="getFileIcon(item.src)"
              style="cursor: pointer"
              :style="
                'max-width:' +
                (getFileType(item.src) === 'image' ? '200px' : '100px') +
                ';max-height:' +
                (getFileType(item.src) === 'image' ? '200px' : '100px')
              "
              @click="downFile(item.src)"
            />
            <div
              style="color: rgb(0, 90, 220); font-size: 12px; cursor: pointer"
              @click="downFile(item.src)"
            >
              {{ item.file_name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog">
      <div style="padding: 5px">
        <Icon
          @click="sendFile"
          style="cursor: pointer"
          size="20"
          type="ios-folder-outline"
        />
      </div>
      <Input
        type="textarea"
        :autosize="{ minRows: 4, maxRows: 8 }"
        :border="false"
        class="chat-input"
        placeholder="客服工作时间：周一至周六的9:00~12:00  14:00~18:00~"
        v-model="describe"
        @keydown.ctrl.enter.native="sendMsg"
      ></Input>
      <div style="text-align: right">
        <Button :type="describe ? 'primary' : 'default'" @click="sendMsg"
          >发送</Button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { apis } from "@/api/workOrderManagement/list.js";
import format from "@/utils/format.js";
export default {
  name: "workOrder",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      serviceIcon: "",
      msg: "hello world",
      messages: [],
      describe: "",
      loading: true,
      type: 1,
    };
  },
  methods: {
    getFileType(url) {
      let imageType = [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "bmp",
        "webp",
        "psd",
        "svg",
        "tiff",
      ];
      let videoType = [
        "mp4",
        "avi",
        "mov",
        "rmvb",
        "rm",
        "flv",
        "3gp",
        "mpeg",
        "mpg",
        "dat",
        "mkv",
        "wmv",
        "asf",
        "asx",
        "ts",
        "tp",
        "m3u8",
      ];
      let audioType = [
        "mp3",
        "wav",
        "wma",
        "ogg",
        "aac",
        "flac",
        "m4a",
        "ape",
        "mid",
        "aiff",
      ];
      let docType = [
        "doc",
        "docx",
        "ppt",
        "pptx",
        "pdf",
        "txt",
        "md",
        "xml",
        "json",
        "csv",
      ];
      let zipType = ["zip", "rar", "7z", "gz", "tar"];
      let excelType = ["xls", "xlsx"];

      let type = url.split(".").pop().toLowerCase();
      if (imageType.includes(type)) {
        return "image";
      } else if (videoType.includes(type)) {
        return "video";
      } else if (audioType.includes(type)) {
        return "audio";
      } else if (docType.includes(type)) {
        return "doc";
      } else if (zipType.includes(type)) {
        return "zip";
      } else if (excelType.includes(type)) {
        return "xls";
      } else {
        return "unknown";
      }
    },
    // 判断文件类型，返回对应的图表
    getFileIcon(url) {
      let type = this.getFileType(url);
      if (type === "image") return url;
      return require("@/assets/images/fileType/" + type + ".png");
    },
    init(data) {
      this.loading = true;
      apis
        .detail({ id: data.id })
        .then((res) => {
          if (res.data.status) {
            this.messages = res.data.payload.reverse();
            this.toBottom();
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    downFile(src) {
      if (this.getFileType(src) === "xls") {
        return window.open(
          // "https://view.officeapps.live.com/op/view.aspx?src=" +
           // encodeURIComponent(src)
          src
        );
      }
      window.open(src, "_blank");
    },
    toBottom() {
      this.$nextTick(() => {
        this.$refs["message"].scrollTop = 0;
        //   this.$refs["message"].scrollTop = this.$refs["message"].scrollHeight;
      });
    },
    sendFile() {
      let file = document.createElement("input");
      file.type = "file";
      file.multiple = true;
      file.click();
      file.onchange = () => {
        this.loading = true;
        const files = Array.from(file.files);
        console.log(files);
        apis
          .reply({ files, id: this.data.id })
          .then((res) => {
            if (res.data.status) {
              this.init(this.data);
            } else {
              this.$Message.error(res.data.msg);
            }
            this.loading = false;
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
          });
      };
    },
    sendMsg() {
      if (!this.describe) return;
      this.messages.unshift({
        type: this.type == 2 ? 1 : 2,
        describe: this.describe,
        create_time: format.customTime(new Date(), "YYYY-MM-DD hh:mm:ss"),
      });
      this.toBottom();
      apis.reply({ id: this.data.id, describe: this.describe });
      this.describe = "";
    },
  },
  mounted() {
    if (this.type == 2)
      this.serviceIcon = require(this.type == 2 &&
        "@/assets/images/service.png");
    console.log(this.data);
    this.init(this.data);
  },
};
</script>
<style lang="less">
.chat-main {
  width: 100%;
  height: 100%;
  background: rgba(248, 249, 251, 100) !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .message-box {
    padding: 10px;
    flex: 1;
    overflow: auto;
    transform: rotate(180deg);
  }
  .left,
  .right {
    display: flex;
    margin-bottom: 10px;
    transform: rotate(180deg);
  }
  .left {
    text-align: left;
    justify-content: left;
  }
  .right {
    text-align: right;
    justify-content: right;
    .message {
      text-align: left;
      background: rgb(0, 90, 220);
      color: rgba(255, 255, 255, 0.85);
    }
  }
  .avatar {
    width: 30px;
    height: 30px;
    margin-right: 5px;
  }
  .username {
    color: rgba(36, 46, 51, 0.7);
    font-size: 14px;
    margin: 0 5px;
  }
  .time {
    font-size: 12px;
  }
  .message {
    background: white;
    border-radius: 3px;
    margin-top: 5px;
    padding: 12px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 10px;
    max-width: 500px;
    display: inline-block;
    white-space: break-spaces;
    line-height: 20px;
    .text {
      white-space: break-spaces;
    }
  }

  .dialog {
    background-color: white;
    border-top: 1px solid #f9f9f9;
    .chat-input {
      textarea {
        resize: none;
      }
    }
  }
}
</style>
